/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portalsignin_OrInputs */



/**
* | output |
* | --- |
* | "or" |
*
* @param {Portalsignin_OrInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const portalsignin_or = /** @type {((inputs?: Portalsignin_OrInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portalsignin_OrInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("or")
});